import React from 'react';
import logo from '../images/PayLOGIKreversedwhite.png';
import {Link as RouterLink} from 'react-router-dom';
import {styled} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import {useTheme} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {CanI, canIFunc, action} from '../CanI';
import {useAppDispatch, useAppSelector} from '../redux/functions/hooks';
import {logout} from '../redux/store/authSlice';
import {purgeStoredState} from 'redux-persist';
import {persistConfig} from '../redux/store/store';
import {useGetIa360ReportingLinkQuery} from '../redux/rtkquery/paylogikApi';
//TODO: Get username from state
//TODO: Update links once pages are built

const navButtons = [
    {
        name: 'Dashboard',
        link: '/',
        local: true,
        functionId: '',
        action: action.VIEW,
    },
    {
        name: 'Invoice Research',
        link: '/invoices',
        local: true,
        functionId: 'Webfrm_InvoiceResearch',
        action: action.VIEW,
    },
    {
        name: 'Approve Invoices',
        link: '/approveinvoices',
        local: true,
        functionId: 'Webfrm_ApproveInv',
        action: action.VIEW,
    },
];

const reportingLinks = [
    {
      name: 'Legacy Reporting',
      link: import.meta.env.VITE_REPORTING_PORTAL_URL,
     local: false,
    functionId: 'Web_LegacyReporting',
    action: action.VIEW,
    },
    {
        name: 'Reporting',
        link: '/reporting',
        local: true,
        functionId: 'Web_PbiOnly',
        action: action.VIEW,
    },
    {
        name: 'Reporting',
        link: '/reporting',
        local: true,
        functionId: 'Web_PbiBeta',
        action: action.VIEW,
    },
];

// Sub-menu link arrays - defined first before main menu arrays that reference them
const paymentFormsLinks = [
    {
        name: 'Receive Funds',
        link: '/accounting/receive-funds',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Make ACH',
        link: '/accounting/make-ach',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Void Checks',
        link: '/accounting/void-checks',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Make Remits',
        link: '/accounting/make-remits',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Cash Receipts',
        link: '/accounting/cash-receipts',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Check Register',
        link: '/accounting/check-register',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Print Checks',
        link: '/accounting/print-checks',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Reprint Checks',
        link: '/accounting/reprint-checks',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Aged Receivables',
        link: '/accounting/aged-receivables',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
];

const customerFeesLinks = [
    {
        name: 'Make Non-Pay-to-Terms',
        link: '/feesApp/non-pay-terms',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Make Pay-to-Terms',
        link: '/feesApp/pay-terms',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Invoice History',
        link: '/feesApp/invoice-history',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Invoice Range',
        link: '/feesApp/invoice-range',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Rule Conversion',
        link: '/feesApp/rule-conversion',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
];

const glCodingLinks = [
    {
        name: 'Coding',
        link: '/glCoding/coding',
        local: true,
        functionId: 'Frm_GLRuleAdmin',
        action: action.VIEW,
    },
    {
        name: 'Rule Admin',
        link: '/glCoding/rule-admin',
        local: true,
        functionId: 'Frm_GLRuleAdmin',
        action: action.VIEW,
    },
];

const invoiceMaintenanceLinks = [
    {
        name: 'Purge Invoice',
        link: '/invoiceMaintenance/purge-invoice',
        local: true,
        functionId: 'Frm_AdvancedInvoiceMaintenance',
        action: action.VIEW,
    },
    {
        name: 'Purge Invoice File',
        link: '/invoiceMaintenance/purge-invoice-file',
        local: true,
        functionId: 'Frm_AdvancedInvoiceMaintenance',
        action: action.VIEW,
    },
    {
        name: 'Unapprove Approved Batch',
        link: '/invoiceMaintenance/unapprove-batch',
        local: true,
        functionId: 'Frm_AdvancedInvoiceMaintenance',
        action: action.VIEW,
    },
    {
        name: 'Unbatch Receivable Batch',
        link: '/invoiceMaintenance/unbatch-batch',
        local: true,
        functionId: 'Frm_AdvancedInvoiceMaintenance',
        action: action.VIEW,
    },
];

const manageImagesLinks = [
    {
        name: 'Image Indexing',
        link: '/manageImages/image-indexing',
        local: true,
        functionId: 'Frm_ManageImages',
        action: action.VIEW,
    },
    {
        name: 'DE Queue',
        link: '/manageImages/de-queue',
        local: true,
        functionId: 'Frm_ManageImages',
        action: action.VIEW,
    },
    {
        name: 'Rush Images',
        link: '/manageImages/rush-images',
        local: true,
        functionId: 'Frm_ManageImages',
        action: action.VIEW,
    },
];

const matchFilesLinks = [
    {
        name: 'Central Salt',
        link: '/matchFiles/central-salt',
        local: true,
        functionId: 'Frm_ManageMatchFile',
        action: action.VIEW,
    },
    {
        name: 'Harcros',
        link: '/matchFiles/harcros',
        local: true,
        functionId: 'Frm_ManageMatchFile',
        action: action.VIEW,
    },
];

const adminFormsLinks = [
    {
        name: 'States',
        link: '/adminForms/states',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Postal Codes',
        link: '/adminForms/postal-codes',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Ref Codes',
        link: '/adminForms/ref-codes',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Code Master',
        link: '/adminForms/code-master',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Mode Override',
        link: '/adminForms/mode-override',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Bank Accounts',
        link: '/adminForms/bank-accounts',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Charge Codes',
        link: '/adminForms/charge-codes',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Carrier Families',
        link: '/adminForms/carrier-families',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Carrier Charge Code Mapping',
        link: '/adminForms/carrier-charge-code-mapping',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Contracts',
        link: '/adminForms/contracts',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'User Roles',
        link: '/adminForms/user-roles',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Users',
        link: '/adminForms/users',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'App Defaults',
        link: '/adminForms/app-defaults',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Secure Defaults',
        link: '/adminForms/secure-defaults',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
];

// Main menu arrays
const carrierLinks = [
    {
        name: 'Invoice Entry',
        link: '/invoiceEntry',
        local: true,
        functionId: 'Frm_InvoiceEntry',
        action: action.VIEW,
    },
    {
        name: 'Manage Exceptions',
        link: '/manageExceptions',
        local: true,
        functionId: 'Frm_ExceptionMgr',
        action: action.VIEW,
    },
    {
        name: 'Manage Images',
        link: '/manageImages',
        local: true,
        functionId: 'Frm_ManageImages',
        action: action.VIEW,
        subMenu: manageImagesLinks,
    },
    {
        name: 'Upload Images',
        link: '/uploadImages',
        local: true,
        functionId: 'Frm_ManageImages',
        action: action.VIEW,
    },
    {
        name: 'Central Salt Tickets',
        link: '/centralSalt',
        local: true,
        functionId: 'Frm_CSaltTicketEntry',
        action: action.VIEW,
    },
    {
        name: 'Match Pay Files',
        link: '/matchFiles',
        local: true,
        functionId: 'Frm_ManageMatchFile',
        action: action.VIEW,
        subMenu: matchFilesLinks,
    },
    {
        name: 'Carrier Admin',
        link: '/carrierAdmin',
        local: true,
        functionId: 'Frm_ManageCarriers',
        action: action.VIEW,
    },
];

const customerLinks = [
    {
        name: 'Receivable Batches',
        link: '/receivables',
        local: true,
        functionId: 'Frm_MakeRecvBatch',
        action: action.VIEW,
    },
    {
        name: 'Image Extract',
        link: '/imageExtract',
        local: true,
        functionId: 'Frm_ManageImages',
        action: action.VIEW,
    },
    {
        name: 'Customer Admin',
        link: '/customerAdmin',
        local: true,
        functionId: 'Frm_ManageBillTo',
        action: action.VIEW,
    },
];

const acctgLinks = [
    {
        name: 'Payment Forms',
        link: '/accounting',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
        subMenu: paymentFormsLinks,
    },
    {
        name: 'Customer Fees',
        link: '/feesApp',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
        subMenu: customerFeesLinks,
    },
    {
        name: 'Customer Fee Rules',
        link: '/feesAppRules',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'GL Coding',
        link: '/glCoding',
        local: true,
        functionId: 'Frm_GLRuleAdmin',
        action: action.VIEW,
        subMenu: glCodingLinks,
    },
    {
        name: 'Mass Reference Update',
        link: '/massRefUpdate',
        local: true,
        functionId: 'Frm_MassUpdates',
        action: action.VIEW,
    },
    {
        name: 'Advanced Invoice Maintenance',
        link: '/invoiceMaintenance',
        local: true,
        functionId: 'Frm_AdvancedInvoiceMaintenance',
        action: action.VIEW,
        subMenu: invoiceMaintenanceLinks,
    },
];

const userLinks = [
    {
        name: 'Admin Forms',
        link: '/adminForms',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
        subMenu: adminFormsLinks,
    },
    {
        name: 'MPI Workaround',
        link: '/itadmin',
        local: true,
        functionId: 'Webfrm_ItAdmin',
        action: action.VIEW,
    },
    {
        name: 'Invoice Research Settings',
        link: '/usersettings',
        local: true,
        functionId: '',
        action: action.VIEW,
    },
];

const StyledToolbar = styled(Toolbar)(({theme}) => ({
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    // Override media queries injected by theme.mixins.toolbar
}));

const LinkBehavior = React.forwardRef((props, ref) => {
    if (props.page) {
        if (props.page.local)
            return <RouterLink ref={ref} to={props.page.link} {...props} />;
        else {
            return (
                <Link
                    href={props.page.useIaUrl ? props.iaurl : props.page.link}
                    target="_blank"
                    rel="noreferrer"
                    {...props}
                />
            );
        }
    } else {
        return <></>;
    }
});

const ExpandableMenu = ({
    buttonId,
    buttonName,
    menuId,
    anchorElement,
    links,
    handleOpen,
    handleClose,
    theme,
    auth,
    subMenus = {},
}) => {
    const shownLinks = links.filter((link) => {
        return canIFunc(auth, link.functionId, link.action);
    });

    return shownLinks.length > 0 ? (
        <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
            <Button
                id={buttonId}
                variant="text"
                key={buttonId}
                onClick={handleOpen}
                sx={{
                    my: 2,
                    color: 'white',
                    fontSize: theme.typography.h6.fontSize,
                }}
                endIcon={<KeyboardArrowDownIcon />}>
                {buttonName}
            </Button>
            <Menu
                sx={{mt: '45px'}}
                id={menuId}
                anchorEl={anchorElement}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElement)}
                onClose={handleClose}>
                {shownLinks.map((page) => {
                    const subMenuConfig = subMenus[page.link];
                    return page.subMenu && subMenuConfig ? (
                        <MenuItem
                            key={page.link}
                            onClick={subMenuConfig.handleOpen}
                            onMouseEnter={subMenuConfig.handleOpen}>
                            <Typography textAlign="center">
                                {page.name}
                            </Typography>
                            <KeyboardArrowRightIcon sx={{ml: 1}} />
                        </MenuItem>
                    ) : (
                        <MenuItem
                            key={page.link}
                            onClick={handleClose}
                            component={LinkBehavior}
                            page={page}>
                            <Typography textAlign="center">
                                {page.name}
                            </Typography>
                        </MenuItem>
                    );
                })}
            </Menu>
            {Object.entries(subMenus).map(([linkPath, config]) => {
                const parentLink = shownLinks.find(
                    (link) => link.link === linkPath
                );
                return parentLink?.subMenu ? (
                    <Menu
                        key={config.id}
                        sx={{mt: '0px', ml: '10px'}}
                        id={config.id}
                        anchorEl={config.anchor}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        open={Boolean(config.anchor)}
                        onClose={config.handleClose}
                        MenuListProps={{
                            onMouseLeave: config.handleClose,
                        }}>
                        {parentLink.subMenu.map((subPage) => (
                            <MenuItem
                                key={subPage.link}
                                onClick={() => {
                                    config.handleClose();
                                    handleClose();
                                }}
                                component={LinkBehavior}
                                page={subPage}>
                                <Typography textAlign="center">
                                    {subPage.name}
                                </Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                ) : null;
            })}
        </Box>
    ) : (
        <></>
    );
};

export default function Header(props) {
    const theme = useTheme();

    const auth = useAppSelector((x) => x.auth);
    const displayName = auth.displayName;
    const initials = auth.initials;
    const dispatch = useAppDispatch();

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElReporting, setAnchorElReporting] = React.useState(null);
    const [anchorElCarrier, setAnchorElCarrier] = React.useState(null);
    const [anchorElCustomer, setAnchorElCustomer] = React.useState(null);
    const [anchorElAcctg, setAnchorElAcctg] = React.useState(null);
    const [anchorElAdminForms, setAnchorElAdminForms] = React.useState(null);
    const [anchorElPaymentForms, setAnchorElPaymentForms] =
        React.useState(null);
    const [anchorElCustomerFees, setAnchorElCustomerFees] =
        React.useState(null);
    const [anchorElGLCoding, setAnchorElGLCoding] = React.useState(null);
    const [anchorElInvoiceMaint, setAnchorElInvoiceMaint] =
        React.useState(null);
    const [anchorElManageImages, setAnchorElManageImages] =
        React.useState(null);
    const [anchorElMatchFiles, setAnchorElMatchFiles] = React.useState(null);

    const {data: iaUrl} = useGetIa360ReportingLinkQuery({});

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleOpenReportingMenu = (event) => {
        setAnchorElReporting(event.currentTarget);
    };
    const handleOpenCarrierMenu = (event) => {
        setAnchorElCarrier(event.currentTarget);
    };
    const handleOpenCustomerMenu = (event) => {
        setAnchorElCustomer(event.currentTarget);
    };
    const handleOpenAcctgMenu = (event) => {
        setAnchorElAcctg(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
        setAnchorElAdminForms(null);
    };
    const handleCloseReportingMenu = () => {
        setAnchorElReporting(null);
    };
    const handleCloseCarrierMenu = () => {
        setAnchorElCarrier(null);
        setAnchorElManageImages(null);
        setAnchorElMatchFiles(null);
    };
    const handleCloseCustomerMenu = () => {
        setAnchorElCustomer(null);
    };
    const handleCloseAcctgMenu = () => {
        setAnchorElAcctg(null);
        setAnchorElPaymentForms(null);
        setAnchorElCustomerFees(null);
        setAnchorElGLCoding(null);
        setAnchorElInvoiceMaint(null);
    };
    const handleOpenAdminFormsMenu = (event) => {
        setAnchorElAdminForms(event.currentTarget);
    };
    const handleCloseAdminFormsMenu = () => {
        setAnchorElAdminForms(null);
    };
    const handleOpenPaymentFormsMenu = (event) => {
        setAnchorElPaymentForms(event.currentTarget);
    };
    const handleClosePaymentFormsMenu = () => {
        setAnchorElPaymentForms(null);
    };
    const handleOpenCustomerFeesMenu = (event) => {
        setAnchorElCustomerFees(event.currentTarget);
    };
    const handleCloseCustomerFeesMenu = () => {
        setAnchorElCustomerFees(null);
    };
    const handleOpenGLCodingMenu = (event) => {
        setAnchorElGLCoding(event.currentTarget);
    };
    const handleCloseGLCodingMenu = () => {
        setAnchorElGLCoding(null);
    };
    const handleOpenInvoiceMaintMenu = (event) => {
        setAnchorElInvoiceMaint(event.currentTarget);
    };
    const handleCloseInvoiceMaintMenu = () => {
        setAnchorElInvoiceMaint(null);
    };
    const handleOpenManageImagesMenu = (event) => {
        setAnchorElManageImages(event.currentTarget);
    };
    const handleCloseManageImagesMenu = () => {
        setAnchorElManageImages(null);
    };
    const handleOpenMatchFilesMenu = (event) => {
        setAnchorElMatchFiles(event.currentTarget);
    };
    const handleCloseMatchFilesMenu = () => {
        setAnchorElMatchFiles(null);
    };

    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <StyledToolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{mr: 2, display: {xs: 'none', md: 'flex'}}}>
                        <img src={logo} alt=""></img>
                    </Typography>

                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit">
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'},
                            }}>
                            {navButtons.map((page) => (
                                <CanI
                                    id={page.name}
                                    key={"CanI" + page.name}
                                    functionId={page.functionId}
                                    action={page.action}>
                                    <MenuItem
                                        key={page.name}
                                        onClick={handleCloseNavMenu}
                                        component={LinkBehavior}
                                        page={page}
                                        iaurl={iaUrl}>
                                        <Typography textAlign="center">
                                            {page.name}
                                        </Typography>
                                    </MenuItem>
                                </CanI>
                            ))}
                        </Menu>
                    </Box>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <img src={logo} alt=""></img>
                    </Typography>
                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}}}>
                        {navButtons.map((page) => (
                            <CanI
                                id={page.name}
                                key={"CanI" + page.name}
                                functionId={page.functionId}
                                action={page.action}>
                                <Button
                                    id={page.name}
                                    variant="text"
                                    key={page.name}
                                    onClick={handleCloseNavMenu}
                                    sx={{
                                        my: 2,
                                        color: 'white',
                                        fontSize: theme.typography.h6.fontSize,
                                    }}
                                    component={LinkBehavior}
                                    page={page}
                                    iaurl={iaUrl}>
                                    {page.name}
                                </Button>
                            </CanI>
                        ))}
                    </Box>

                    <ExpandableMenu
                        buttonId="reportingMenu"
                        buttonName="Reporting"
                        menuId="menu-reporting"
                        anchorElement={anchorElReporting}
                        links={reportingLinks}
                        handleOpen={handleOpenReportingMenu}
                        handleClose={handleCloseReportingMenu}
                        theme={theme}
                        auth={auth}
                    />

                    <ExpandableMenu
                        buttonId="carrierMenu"
                        buttonName="Carrier"
                        menuId="menu-carrier"
                        anchorElement={anchorElCarrier}
                        links={carrierLinks}
                        handleOpen={handleOpenCarrierMenu}
                        handleClose={handleCloseCarrierMenu}
                        theme={theme}
                        auth={auth}
                        subMenus={{
                            '/manageImages': {
                                id: 'menu-manage-images',
                                anchor: anchorElManageImages,
                                handleOpen: handleOpenManageImagesMenu,
                                handleClose: handleCloseManageImagesMenu,
                            },
                            '/matchFiles': {
                                id: 'menu-match-files',
                                anchor: anchorElMatchFiles,
                                handleOpen: handleOpenMatchFilesMenu,
                                handleClose: handleCloseMatchFilesMenu,
                            },
                        }}
                    />

                    <ExpandableMenu
                        buttonId="custMenu"
                        buttonName="Customer"
                        menuId="menu-customer"
                        anchorElement={anchorElCustomer}
                        links={customerLinks}
                        handleOpen={handleOpenCustomerMenu}
                        handleClose={handleCloseCustomerMenu}
                        theme={theme}
                        auth={auth}
                    />

                    <ExpandableMenu
                        buttonId="acctgMenu"
                        buttonName="Accounting"
                        menuId="menu-accounting"
                        anchorElement={anchorElAcctg}
                        links={acctgLinks}
                        handleOpen={handleOpenAcctgMenu}
                        handleClose={handleCloseAcctgMenu}
                        theme={theme}
                        auth={auth}
                        subMenus={{
                            '/accounting': {
                                id: 'menu-payment-forms',
                                anchor: anchorElPaymentForms,
                                handleOpen: handleOpenPaymentFormsMenu,
                                handleClose: handleClosePaymentFormsMenu,
                            },
                            '/feesApp': {
                                id: 'menu-customer-fees',
                                anchor: anchorElCustomerFees,
                                handleOpen: handleOpenCustomerFeesMenu,
                                handleClose: handleCloseCustomerFeesMenu,
                            },
                            '/glCoding': {
                                id: 'menu-gl-coding',
                                anchor: anchorElGLCoding,
                                handleOpen: handleOpenGLCodingMenu,
                                handleClose: handleCloseGLCodingMenu,
                            },
                            '/invoiceMaintenance': {
                                id: 'menu-invoice-maintenance',
                                anchor: anchorElInvoiceMaint,
                                handleOpen: handleOpenInvoiceMaintMenu,
                                handleClose: handleCloseInvoiceMaintMenu,
                            },
                        }}
                    />

                    <Box sx={{flexGrow: 0}}>
                        <Tooltip title="Open settings">
                            <IconButton
                                onClick={handleOpenUserMenu}
                                sx={{p: 0}}>
                                <Avatar alt={displayName}>{initials}</Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{mt: '45px'}}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}>
                            {userLinks.map((page) => (
                                <CanI
                                    id={page.name}
                                    functionId={page.functionId}
                                    action={page.action}
                                    key={page.name}>
                                    {page.subMenu ? (
                                        <MenuItem
                                            onClick={handleOpenAdminFormsMenu}
                                            onMouseEnter={
                                                handleOpenAdminFormsMenu
                                            }>
                                            <Typography textAlign="center">
                                                {page.name}
                                            </Typography>
                                            <KeyboardArrowRightIcon
                                                sx={{ml: 1}}
                                            />
                                        </MenuItem>
                                    ) : (
                                        <MenuItem
                                            key={'settings'}
                                            onClick={handleCloseUserMenu}
                                            component={LinkBehavior}
                                            page={page}>
                                            <Typography textAlign="center">
                                                {page.name}
                                            </Typography>
                                        </MenuItem>
                                    )}
                                </CanI>
                            ))}
                            <MenuItem
                                key={'Clear Local Session'}
                                onClick={() => {
                                    handleCloseUserMenu();
                                    purgeStoredState(persistConfig).then(() => {
                                        window.location.reload();
                                    });
                                }}>
                                <Typography textAlign="center">
                                    Clear Local Session
                                </Typography>
                            </MenuItem>
                            <MenuItem
                                key={'Log Out'}
                                onClick={() => {
                                    handleCloseUserMenu();
                                    dispatch(logout());
                                }}>
                                <Typography textAlign="center">
                                    Log Out
                                </Typography>
                            </MenuItem>
                        </Menu>
                        <Menu
                            sx={{mt: '0px', ml: '10px'}}
                            id="menu-admin-forms"
                            anchorEl={anchorElAdminForms}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElAdminForms)}
                            onClose={handleCloseAdminFormsMenu}
                            MenuListProps={{
                                onMouseLeave: handleCloseAdminFormsMenu,
                            }}>
                            {adminFormsLinks.map((subPage) => (
                                <CanI
                                    id={subPage.name}
                                    functionId={subPage.functionId}
                                    action={subPage.action}
                                    key={subPage.name}>
                                    <MenuItem
                                        onClick={() => {
                                            handleCloseAdminFormsMenu();
                                            handleCloseUserMenu();
                                        }}
                                        component={LinkBehavior}
                                        page={subPage}>
                                        <Typography textAlign="center">
                                            {subPage.name}
                                        </Typography>
                                    </MenuItem>
                                </CanI>
                            ))}
                        </Menu>
                    </Box>
                </StyledToolbar>
            </Container>
        </AppBar>
    );
}
